/* eslint-disable camelcase */

import type {AxiosResponse} from 'axios';
import type {
  ApiPayloadBundleProps,
  ApiPayloadBundleProduct,
  BundleProductProps,
  BundleProps,
} from '@/redux/reducers/typings';

/**
 * @description Selects the bundle product necessary data from the API response
 * @param {object} apiProduct full product data from the API
 * @return {object} bundle product selected data
 */
export const formatBundleProductData = ({
  id,
  name,
  slug,
  artist_name,
  category_full_name,
  pricing,
  thumbor_images = [],
}: ApiPayloadBundleProduct): BundleProductProps => ({
  id,
  name,
  slug,
  artist_name,
  category_full_name,
  pricing,
  thumbor_images,
});

/**
 * @description Selects the add to bundle data from the API response
 * @param {object} apiResponseBody full bundle data data from the API
 * @return {object} bundle selected data
 */
export const formatAddToBundleData = ({
  pricing,
  discount_percentage,
  main_product,
  bundle_product,
}: ApiPayloadBundleProps): BundleProps => ({
  pricing,
  discount_percentage,
  main_product: formatBundleProductData(main_product),
  bundle_product: formatBundleProductData(bundle_product),
});

/**
 * @description Formats the Axios response for the get bundle action
 * @param {object} params - Axios success response object
 * @return {object} formatted Axios response object with selected bundle data
 */
export const formatGetBundle = ({
  data,
  ...restAxiosResponse
}: AxiosResponse<ApiPayloadBundleProps>): AxiosResponse<BundleProps> => ({
  ...restAxiosResponse,
  data: formatAddToBundleData(data),
});
